import axios from "axios";

export const getWebengageWhitelist = async () => {
    return axios
        .get(
            `${process.env.REACT_APP_SSO_BASE_URL_AUTH}/general/api/v1/settings/event-whitelist/`
        )
        .then((response) => {
            return response?.data;
        })
        .catch((error) => {
            return error;
        });
};
